import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { CATEGORY_SINGULAR } from "@/lib/categories";

export default function ProductCard({ product }) {
    const prices = (product.variants || []).map((v) => v.price_cad);
    const min = prices.length ? Math.min(...prices) : 0;
    const max = prices.length ? Math.max(...prices) : 0;

    return (
        <Link
            to={`/produit/${product.slug}`}
            data-testid={`product-card-${product.slug}`}
            className="glass-card rounded-2xl overflow-hidden group block"
        >
            <div className="zoom-wrap aspect-square bg-black/40">
                <img
                    src={fileUrl(product.images?.[0])}
                    alt={product.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                />
            </div>
            <div className="p-5">
                <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-1">
                    {CATEGORY_SINGULAR[product.category] || product.category}
                </div>
                <h3 className="font-serif-luxe text-xl text-slate-100">{product.name}</h3>
                <p className="text-xs text-slate-400 mt-1 line-clamp-2">{product.short_description}</p>
                <div className="mt-3 flex items-center justify-between">
                    <div data-testid={`product-price-${product.slug}`} className="text-sm font-semibold text-slate-200">
                        {min === max ? `${min.toFixed(0)} $` : `${min.toFixed(0)} $ — ${max.toFixed(0)} $`} CAD
                    </div>
                    <div className="flex items-center gap-2">
                        {product.availability === "commande" && (
                            <span data-testid={`product-made-to-order-${product.slug}`} className="text-[10px] uppercase tracking-widest text-[#D97706]">Sur commande</span>
                        )}
                        <div data-testid={`product-finishes-${product.slug}`} className="flex items-center gap-1" title="Plaqué or 14kt : jaune, blanc ou rose">
                            <span className="w-3 h-3 rounded-full border border-white/30" style={{ background: "linear-gradient(135deg,#F1F5F9,#94A3B8)" }} />
                            <span className="w-3 h-3 rounded-full border border-white/30" style={{ background: "linear-gradient(135deg,#FDE68A,#B45309)" }} />
                            <span className="w-3 h-3 rounded-full border border-white/30" style={{ background: "linear-gradient(135deg,#FECDD3,#BE5A6B)" }} />
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
}
